// extracted by mini-css-extract-plugin
export default {"title":"JV3Cnc"};